import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'egi-kpi',
  templateUrl: './egi-kpi.component.html',
  styleUrls: ['./egi-kpi.component.css'],
})
export class EgiKpiComponent implements OnInit {
  @Input() main: string | number | boolean;
  @Input() mainDesc: string | number;
  @Input() secondary: string | number | boolean;
  @Input() secDesc: string | number;
  @Input() textSize: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() info: any;

  constructor() {}

  ngOnInit(): void {}
}
